import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const peopleStaffTrendWidget: DashboardWidgetConfiguration = {
  widgetId: "people.staff-trend",
  name: "Staff growth",
  description: "A dotted line chart of employment starts.",
  apps: [
    "home",
    "hr",
    "attendance",
    "payroll",
    "recruitment",
    "schedule-planning",
    "time-off",
    "timesheets",
    "project",
    "field-service",
  ],
  template: "graph",
  query: {
    kind: "graph",
    valueQuery: {
      version: 1,
      source: "hr.employments",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "employment_id",
          as: "new_staff",
        },
      ],
    },
    graphQueries: [
      {
        name: "New staff",
        query: {
          version: 1,
          source: "hr.employments",
          ...period(30),
          select: [
            {
              type: "field",
              field: "start_date",
              bucket: "day",
              as: "day",
            },
            {
              type: "aggregate",
              function: "count_distinct",
              field: "employment_id",
              as: "new_staff",
            },
          ],
          group_by: [
            {
              field: "start_date",
              bucket: "day",
            },
          ],
          order_by: [
            {
              ref: "day",
              direction: "asc",
            },
          ],
        },
        type: "line",
        color: "#ae3ec9",
        lineWidth: 3,
        dashed: true,
        showMarkers: true,
      },
    ],
  },
  inputs: {
    title: "Staff growth",
    graphPadding: true,
    chartHeight: 80,
    curve: "straight",
  },
  dummyData: {
    value: 24,
    series: [
      1,
      3,
      2,
      5,
      4,
      6,
      3,
    ],
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 2,
    maxHeight: 6,
    defaultWidth: 4,
    defaultHeight: 2,
  },
};
